import { useContext } from "react";
import Image from "next/image";
import Link from "next/link";
import { headerContext } from "../../services/context";
import { fetchStripeCustomerPortalInfo } from "../../services/payments/stripe";
import { useRouter } from "next/router";
import Logo from "../images/The_Boho_Market_Logo.png";
import mainLogo from "../../public/images/mainLogo.svg";

const Footer = () => {
  const { headerInfo } = useContext(headerContext);

  const router = useRouter();

  const stripeCreateSession = async () => {
    const returnUrl = `${process.env.NEXT_PUBLIC_BASE_HOST}/dashboard`;
    //const returnUrl = 'http://localhost:3000/dashboard';

    const data = {
      return_url: returnUrl,
    };
    const stripePortalUrl = await fetchStripeCustomerPortalInfo(data);

    window.open(stripePortalUrl.portal_url, "_blank");
    //router.push(stripePortalUrl.portal_url);
  };

  return (
    <footer className="footer">
      <div className="footer__content">
        <div className="footer__section">
          <div className="footer__logo">
            <Link href="/dashboard">
              <a>
                <Image
                  src={mainLogo}
                  style={{marginBottom: -10, marginLeft: -50}}
                  width="350"
                  height="125"
                  alt="Footer image"
                />
              </a>
            </Link>
          </div>
          <p>
          Established in 2016, The Boho Market is Texas' largest network of artisans, 
          hosting the most pop-up markets statewide. Annually, we serve hundreds of 
          thousands of Texans, empowering over 7,000 local businesses to showcase 
          and sell their goods to a vast audience.
          </p>
        </div>
        <div className="footer__section">
          <h6>Sitemap</h6>
          <Link href="/dashboard">
            <a>Dashboard</a>
          </Link>
          {(headerInfo.accountStatus === "approved" ||
            headerInfo.legacyStatus === "approved") && (
            <Link href="/events/all-events" prefetch={false}>
              <a>All Boho Events</a>
            </Link>
          )}
          {(headerInfo.accountStatus === "approved" ||
            headerInfo.legacyStatus === "approved") && (
            <Link href="/accounts/my-events">
              <a>My Events</a>
            </Link>
          )}
          {(headerInfo.accountStatus === "approved" ||
            headerInfo.legacyStatus === "approved") && (
            <div
              onClick={() => stripeCreateSession()}
              className="dropdown__linkFooter"
            >
              <button>
                <p className="dropdown__linkPayment">My Invoices</p>
              </button>
            </div>
          )}
          <Link href="/vendor-faq">
            <a>Vendor FAQs</a>
          </Link>
        </div>
        <div className="footer__section">
          <h6>Company</h6>
          <Link href="/accounts/privacy">
            <a>Privacy Policy</a>
          </Link>
          <Link href="/accounts/terms">
            <a>Terms of Service</a>
          </Link>
          <Link href="/contact">
            <a>Contact Us</a>
          </Link>
        </div>
      </div>
      <p>
        {new Date().getFullYear()} THE BOHO MARKET, LLC | DALLAS, TEXAS 75211
      </p>
    </footer>
  );
};

export default Footer;
